import { Modal } from "antd";
import { useNavigate } from "react-router-dom"; 
import declineIcon from "../../../app/assets/images/ewa (20) 2.png";
import approveIcon from "../../../app/assets/images/ewa (20) 1.png";
import PropTypes from "prop-types";

const OfferLetterOptionModal = ({ isVisible, onCancel }) => {
  const navigate = useNavigate();

  const handleSelection = (status) => {
    navigate(`offer-letter`, { state: { status } });
    
    onCancel();
  };

  return (
    <Modal open={isVisible} onCancel={onCancel} footer={null} width={900} className="offer-letter-modal">
      <div className="flex flex-col items-center px-14 pb-8">
        <h2 className="text-3xl font-bold uppercase mb-8 p-0 text-[#ff7201] tracking-tight">Offer Letter</h2>

        <div className="flex justify-center gap-4 w-full mb-12">
          <div
            onClick={() => handleSelection("Declined")}
            className="flex-1 bg-[#F48E33] hover:bg-[#e67e22] text-white rounded-2xl p-4 flex items-center justify-center gap-4 cursor-pointer shadow-md transition-all active:scale-95"
          >
            <div className="flex flex-col items-center gap-1">
              <img src={declineIcon} className="h-20 w-auto" alt="decline" />
            </div>
            <span className="text-2xl font-semibold">Declined</span>
          </div>

          <div
            onClick={() => handleSelection("Approved")}
            className="flex-1 bg-[#F48E33] hover:bg-[#e67e22] text-white rounded-2xl p-4 flex items-center justify-center gap-4 cursor-pointer shadow-md transition-all active:scale-95"
          >
            <div className="flex flex-col items-center">
              <img src={approveIcon} className="h-20 w-auto" alt="approve" />
            </div>
            <span className="text-2xl font-semibold">Approved</span>
          </div>

          <div
            onClick={() => handleSelection("Offered")}
            className="flex-1 bg-[#F48E33] hover:bg-[#e67e22] text-white rounded-2xl p-4 flex items-center justify-center gap-4 cursor-pointer shadow-md transition-all active:scale-95"
          >
            <div className="flex flex-col items-center">
              <img src={approveIcon} className="h-20 w-auto" alt="approve" />
            </div>
            <span className="text-2xl font-semibold">Offered</span>
          </div>
        </div>

        <button
          onClick={onCancel}
          className="bg-[#757575] hover:bg-[#616161] cursor-pointer border-none outline-none text-white px-10 py-2 rounded-full font-bold uppercase tracking-widest text-sm"
        >
          Exit
        </button>
      </div>
    </Modal>
  );
};

OfferLetterOptionModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default OfferLetterOptionModal;
